import api from './api';

const statesService = {
  getAll: async () => {
    const response = await api.get('/state/get-state');
    return response.data.data || response.data;
  },

  create: async (data) => {
    const response = await api.post('/state/add-state', data);
    return response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/state/update-state/${id}`, data);
    return response.data.data || response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/state/delete-state/${id}`);
    return response.data;
  },
};

export default statesService;
